<template>
  <div class="mobile">
    <div class="container">
      <!--KV-->
      <div class="m_bg">
        <div class="d-swiper">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide>
              <a href="http://www.sonystyle.com.cn/wechat_app/promotion/20180601/index.htm"><img src="../assets/image/homepage/kv/750x463_sf_0611.jpg"></a>
            </swiper-slide>
            <swiper-slide>
              <a href="http://www.sonystyle.com.cn/wechat_app/product.html?productLink=mobile_app/dsc_40/dsc_rx100m6.4.json"><img src="../assets/image/homepage/kv/750x463_rx100m6_0606.jpg"></a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <!--<div class="swiper-container">-->
          <!--<div class="swiper-wrapper">-->
            <!--<div class="swiper-slide">-->
              <!--<a href="http://www.sonystyle.com.cn/wechat_app/promotion/20180601/index.htm"><img src="../assets/image/homepage/kv/750x463_sf_0611.jpg"></a>-->
            <!--</div>-->
            <!--<div class="swiper-slide">-->
              <!--<a href="http://www.sonystyle.com.cn/wechat_app/product.html?productLink=mobile_app/dsc_40/dsc_rx100m6.4.json"><img src="../assets/image/homepage/kv/750x463_rx100m6_0606.jpg"></a>-->
            <!--</div>-->
            <!--<div class="swiper-slide">-->
              <!--<a href="http://www.sonystyle.com.cn/wechat_app/promotion/soccer2018/index.htm"><img src="../assets/image/homepage/kv/750x463_soccer2018_0605.jpg"></a>-->
            <!--</div>-->
            <!--<div class="swiper-slide">-->
              <!--<a href="http://www.sonystyle.com.cn/wechat_app/promotion/pa_20180518/index.htm"><img src="../assets/image/homepage/kv/750x463_dlrb_0528.jpg"></a>-->
            <!--</div>-->

            <!--<div class="swiper-slide">-->
              <!--<a href="http://www.sonystyle.com.cn/wechat_app/product.html?productLink=mobile_app/bravia_40/a8f.4.json"><img src="../assets/image/homepage/kv/750x463_a8f_0521.jpg"></a>-->
            <!--</div>-->
            <!--<div class="swiper-slide">-->
              <!--<a href="http://www.sonystyle.com.cn/wechat_app/product.html?productLink=mobile_app/srs_40/srs_xb41.4.json"><img src="../assets/image/homepage/kv/750x463_xb41_0524.jpg"></a>-->
            <!--</div>-->
            <!--<div class="swiper-slide">-->
              <!--<a href="http://www.sonystyle.com.cn/products/handycam/ax700kol/kol/mobile.htm"><img src="../assets/image/homepage/kv/750x463_ax700_0521.jpg"></a>-->
            <!--</div>-->

          <!--</div>-->
          <!--<div class="swiper-pagination"></div>-->
        <!--</div>-->
      </div>
      <div id="NewProduct" class="cf">
        <div class="NewProduct_main">
          <h3>新品发布 </h3>
          <ul class="cf">
            <!--/127.htm-->
            <li @click="goProduct(item.eightd)" v-for="item in newproduct">
              <!--<a :href="item.link">-->
                <div class="NewProBlock">
                  <div class="txtC">
                    <h3 v-html="item.title"></h3>
                    <p class="vice" v-html="item.subtitle"></p>


                    <p title="BD_" class="p_rice status status_1"><span class="money"></span></p>

                  </div>


                  <img class="NewProPic lazy" :src="BASE_URL+item.image">
                </div>
              <!--</a>-->
            </li> <!--/125.htm-->
            <!--</li>-->
          </ul>
        </div>
      </div>

      <div class="MainBlock cf" v-for="item in block">
        <div id="MainB1" class="ProductBlock bgGrey cf">
          <div id="DI" class="MainProductBlock DI cf">
            <div class="MainBlockTop cf">
              <h3 class="tit cf" style="background:url(images/blocktitlelogo.png) no-repeat left center;">{{item.title}}</h3>

            </div>

            <div class="MainBlock cf">

              <div class="MBlock_h mr10">
                <!--世界杯/130.htm-->

              <template v-for="mblock in item.leftItems">
                <div v-if="mblock.type" :class="[mblock.align=='right'?'right':'left','Block'+mblock.type,'MBlock','bigblock','mtb10','whitebg']">
                  <div class="price_zone1 price_zone">
                    <div class="txt" v-if="!mblock.onlyImage">

                      <p class="s_title" v-html="mblock.title"></p>
                      <h3 v-html="mblock.subtitle"></h3>
                      <i class="member_status"></i>
                      <p title="BD_P50001377" class="p_rice status status_1">
                        <span class="money"></span>
                      </p>
                      <span class="icon"><img alt="618大促" src="/images/618th.png" /></span>

                    </div>

                  </div>

                  <div :class="[(mblock.onlyImage)?'product_img0':'',(!mblock.onlyImage&&mblock.type==2)?'product_img2':'',(!mblock.onlyImage&&(mblock.type==3||mblock.type==4))?'product_img3':'']">
                    <img class="w451 lazy" alt="ICLE-A7RM3" :src="BASE_URL+mblock.image" data-original="/images/block_sjb_di.jpg">
                  </div>
                  <div v-if="mblock.techIcon1" class="hires_icon1"><img alt="ZEISS_logo" :src="BASE_URL+mblock.techIcon1"></div>
                  <div v-if="mblock.techIcon2" class="hires_icon2"><img alt="ZEISS_logo" :src="BASE_URL+mblock.techIcon2"></div>

                </div>
              </template>


              </div>
              <div class="MBlock_h ">
                <template v-for="mblock in item.rightItems">
                  <div v-if="mblock.type" :class="[mblock.align=='right'?'right':'left','Block'+mblock.type,'MBlock','bigblock','mtb10','whitebg']">
                    <div class="price_zone1 price_zone">
                      <div class="txt" v-if="!mblock.onlyImage">

                        <p class="s_title" v-html="mblock.title"></p>
                        <h3 v-html="mblock.subtitle"></h3>
                        <i class="member_status"></i>
                        <p title="BD_P50001377" class="p_rice status status_1">
                          <span class="money"></span>
                        </p>
                        <span class="icon"><img alt="618大促" src="/images/618th.png" /></span>

                      </div>

                    </div>

                    <div :class="[(mblock.onlyImage)?'product_img0':'',(!mblock.onlyImage&&mblock.type==2)?'product_img2':'',(!mblock.onlyImage&&(mblock.type==3||mblock.type==4))?'product_img3':'']">
                      <img class="w451 lazy" alt="ICLE-A7RM3" :src="BASE_URL+mblock.image" data-original="/images/block_sjb_di.jpg">
                    </div>
                    <div v-if="mblock.techIcon1" class="hires_icon1"><img alt="ZEISS_logo" :src="BASE_URL+mblock.techIcon1"></div>
                    <div v-if="mblock.techIcon2" class="hires_icon2"><img alt="ZEISS_logo" :src="BASE_URL+mblock.techIcon2"></div>

                  </div>
                </template>
              </div>


            </div>
          </div>
        </div>
      </div>
      <div class="MainBlock cf">
        <div id="MainB5" class="ProductBlock bgBlue cf">
          <div id="MySonyClub" class="MainProductBlock MySonyClub cf">
            <div class="MainBlockTop cf">
              <h3 class="tit cf" style="background:url(images/blocktitlelogo4.png) no-repeat left center;">My Sony Club会员专区 </h3>

            </div>

            <div class="MainBlock cf">
              <div class="MBlock_h mr10">
                <a v-for="item in mysony.leftItems" href="https://www.sonystyle.com.cn/mysony/acafe/GlobalPortrait/index.htm?ssid=Portrait_201806_sonystyle" data-loc="Cell" data-block="a2">
                  <div :class="[item.align=='right'?'right':'left','Block'+item.type,'MBlock','bigblock','mtb10','bluebg']">
                    <div class="product_img0">
                      <img class="onlyimg lazy" alt="人像摄影大赛" data-original="/images/block_syds_0601.jpg" src="../assets/image/homepage/block_syds_0601.jpg">
                    </div>
                  </div>
                </a>
              </div>
              <div class="MBlock_h ">
                <a v-for="item in mysony.rightItems" href="https://www.sonystyle.com.cn/mysony/acafe/GlobalPortrait/index.htm?ssid=Portrait_201806_sonystyle" data-loc="Cell" data-block="a2">
                  <div :class="[item.align=='right'?'right':'left','Block'+item.type,'MBlock','bigblock','mtb10','bluebg']">
                    <div class="product_img0">
                      <img class="onlyimg lazy" alt="人像摄影大赛" data-original="/images/block_syds_0601.jpg" src="../assets/image/homepage/snyx.jpg">
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="MainBlock cf">

              <a class="backTohead" href="javascript:;"><img src="../assets/image/homepage/backtohead.png"></a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<style scoped>
@import "./../assets/css/mobile_0413.css";
@import "./../assets/css/homepage.css";
@import "./../assets/css/main.css";
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
import * as $bg from "../commons/utils/bridge.js";
import LINKTYPE from "../commons/utils/linktype.js";

import indexData from "../assets/json/index";
export default {
  data() {
    return {
      BASE_URL: BASE_URL,
      api: this.$store.state.api,
      kv: [],
      block: [],
      newproduct: [],
      mysony: {},
      swiperOption: {
        notNextTick: true,
        autoplay: 3000,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        pagination: { el: ".swiper-pagination" },
        click: true,
        tap: true
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  created() {
    this.getData();
  },
  mounted() {
    this.setHeight();
  },
  methods: {
    goProduct(_8d) {
      //alert(LINKTYPE.PDP);
      if ($bg.isSonyApp()) {
        let ed = {};
        ed.link_type = LINKTYPE.PDP;
        ed.link =LINKTYPE.makePDPLink(_8d);
        ed.title = "产品详情";
        ed.action = LINKTYPE.makeAction(ed.link_type);

        $bg.doAppAction(ed);
      } else {
        this.$router.push({
          path: "/Product",
          query: {
            eightD: _8d
          }
        });
      }

      console.log("current path", this.$router.currentRoute);
    },
    getData() {
      this.newproduct = indexData.newproduct;
      this.block = indexData.block;
      this.mysony = indexData.mysony;
      let url = this.api.search.index();
      this.$http.get(url).then(res => {
        if (res.data) {
          this.kv = res.data.kv;
          this.block = res.data.block;
          this.newproduct = res.data.newproduct;
          this.mysony = res.data.mysony;
        }
      });
    },
    setHeight() {
      var width = document.documentElement.clientWidth * 0.94;
      var halfwidth = document.documentElement.clientWidth * 0.94 * 0.49;
      Array.from(document.getElementsByClassName("Block1")).forEach(
        (el, index) => {
          document.getElementsByClassName("Block1")[index].style.height =
            295 / 600 * width + "px";
        }
      );
      Array.from(document.getElementsByClassName("Block2")).forEach(
        (el, index) => {
          document.getElementsByClassName("Block2")[index].style.height =
            398 / 295 * halfwidth + "px";
        }
      );
      Array.from(document.getElementsByClassName("Block3")).forEach(
        (el, index) => {
          document.getElementsByClassName("Block3")[index].style.height =
            194 / 295 * halfwidth + "px";
        }
      );
      Array.from(document.getElementsByClassName("Block4")).forEach(
        (el, index) => {
          document.getElementsByClassName("Block4")[index].style.height =
            halfwidth + "px";
        }
      );
      Array.from(document.getElementsByClassName("Block5")).forEach(
        (el, index) => {
          document.getElementsByClassName("Block5")[index].style.height =
            703 / 600 * width + "px";
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue